.avatar {
  position: relative;
  display: grid;
  place-items: center;
  flex-shrink: 0;
  border-radius: 50%;
  background: var(--gradient-brand);
  color: #fff;
  font-weight: 700;
  letter-spacing: -0.02em;
  overflow: hidden;
  box-shadow: 0 0 0 2px var(--surface-solid);
}

.ring {
  box-shadow:
    0 0 0 2px var(--surface-solid),
    0 0 0 4px var(--brand-500),
    0 0 22px -4px var(--brand-glow);
}

.image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
